<script>
  import { onMount, tick } from 'svelte';

  let councilResults = [];
  let welshResults = [];
  let scottishConstituencyResults = [];
  let scottishRegionalResults = [];

  let postcode = '';
  let matchedResults = [];
  let lookupMessage = '';

  const ENGLISH_COUNCIL_URL =
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQLDbyY05UgtsYc4KDaltZkd5akG9l_lBpsqipoLoX1nzy7Hw4OGFQ85jeZJdkPaxBdiicfEBhuq2O0/pub?gid=68197314&single=true&output=csv';

  const WELSH_PARLIAMENT_URL =
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQLDbyY05UgtsYc4KDaltZkd5akG9l_lBpsqipoLoX1nzy7Hw4OGFQ85jeZJdkPaxBdiicfEBhuq2O0/pub?gid=1302705231&single=true&output=csv';

  const SCOTTISH_CONSTITUENCY_URL =
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQLDbyY05UgtsYc4KDaltZkd5akG9l_lBpsqipoLoX1nzy7Hw4OGFQ85jeZJdkPaxBdiicfEBhuq2O0/pub?gid=434094866&single=true&output=csv';

  const SCOTTISH_REGION_URL =
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQLDbyY05UgtsYc4KDaltZkd5akG9l_lBpsqipoLoX1nzy7Hw4OGFQ85jeZJdkPaxBdiicfEBhuq2O0/pub?gid=847931673&single=true&output=csv';

  const welshWestminsterToSeneddMap = {
    'aberafan maesteg': 'W09000048',
    'rhondda and ogmore': 'W09000048',
    'bangor aberconwy': 'W09000049',
    'ynys mon': 'W09000049',
    'ynys môn': 'W09000049',
    'blaenau gwent and rhymney': 'W09000050',
    'caerphilly': 'W09000050',
    'brecon, radnor and cwm tawe': 'W09000051',
    'brecon radnor and cwm tawe': 'W09000051',
    'neath and swansea east': 'W09000051',
    'cardiff north': 'W09000052',
    'cardiff east': 'W09000052',
    'cardiff west': 'W09000053',
    'cardiff south and penarth': 'W09000053',
    'newport east': 'W09000054',
    'newport west and islwyn': 'W09000054',
    'ceredigion preseli': 'W09000055',
    'mid and south pembrokeshire': 'W09000055',
    'clwyd east': 'W09000056',
    'clwyd north': 'W09000056',
    'alyn and deeside': 'W09000057',
    'wrexham': 'W09000057',
    'dwyfor meirionnydd': 'W09000058',
    'montgomeryshire and glyndwr': 'W09000058',
    'montgomeryshire and glyndŵr': 'W09000058',
    'gower': 'W09000059',
    'swansea west': 'W09000059',
    'bridgend': 'W09000060',
    'vale of glamorgan': 'W09000060',
    'merthyr tydfil and aberdare': 'W09000061',
    'pontypridd': 'W09000061',
    'monmouthshire': 'W09000062',
    'torfaen': 'W09000062',
    'caerfyrddin': 'W09000063',
    'llanelli': 'W09000063'
  };

const scottishRegionNameMap = {
  'central and lothians west scotland': 'scotland central and lothians west',
  'edinburgh and lothians east': 'edinburgh and lothians east',
  'glasgow': 'glasgow',
  'highlands and islands': 'highlands and islands',
  'mid and fife scotland': 'scotland mid and fife',
  'north east scotland': 'scotland north east',
  'south scotland': 'scotland south',
  'west scotland': 'scotland west'
};


  const partySets = {
    england: [
      ['labour', 'LAB_seats'],
      ['conservative', 'CON_seats'],
      ['libDem', 'LD_seats'],
      ['green', 'GRN_seats'],
      ['reform', 'REF_seats'],
      ['independent', 'IND_seats'],
      ['other', 'OTH_seats']
    ],
    wales: [
      ['labour', 'LAB_seats'],
      ['plaidCymru', 'PC_seats'],
      ['conservative', 'CON_seats'],
      ['libDem', 'LD_seats'],
      ['green', 'GRN_seats'],
      ['reform', 'REF_seats'],
      ['independent', 'IND_seats'],
      ['other', 'OTH_seats']
    ],
    scotlandConstituency: [
      ['snp', 'SNP_pct'],
      ['labour', 'LAB_pct'],
      ['conservative', 'CON_pct'],
      ['libDem', 'LD_pct'],
      ['green', 'GRN_pct'],
      ['reform', 'REF_pct'],
      ['alba', 'ALB_pct'],
      ['independent', 'IND_pct'],
      ['other', 'OTH_pct']
    ],
    scotlandRegion: [
      ['snp', 'SNP_seats'],
      ['labour', 'LAB_seats'],
      ['conservative', 'CON_seats'],
      ['libDem', 'LD_seats'],
      ['green', 'GRN_seats'],
      ['reform', 'REF_seats'],
      ['alba', 'ALB_seats'],
      ['independent', 'IND_seats'],
      ['other', 'OTH_seats']
    ]
  };

  function normaliseName(value) {
    return value
      ?.toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseRow(row, delimiter) {
    return row.split(delimiter).map(cell => cell.trim());
  }

  function sendIframeHeight() {
    if (typeof window === 'undefined') return;

    window.parent.postMessage(
      {
        type: 'iframe_height',
        height: document.documentElement.scrollHeight
      },
      '*'
    );
  }

  function getPartySet(type) {
    if (type === 'wales') return partySets.wales;
    if (type === 'scotland_constituency') return partySets.scotlandConstituency;
    if (type === 'scotland_region') return partySets.scotlandRegion;
    return partySets.england;
  }

  async function loadCsv(url, type) {
    const response = await fetch(url);
    const text = await response.text();

    const lines = text.split('\n').filter(line => line.trim() !== '');
    const delimiter = lines[0].includes('\t') ? '\t' : ',';

    const header = parseRow(lines[0], delimiter);
    const rows = lines.slice(1);
    const partySet = getPartySet(type);

    console.log(`${type} header:`, header);

    return rows.map(line => {
      const cols = parseRow(line, delimiter);

      const get = key => {
        const index = header.indexOf(key);
        return index === -1 ? '' : cols[index] || '';
      };

      const values = {};

      partySet.forEach(([key, column]) => {
        values[key] = get(column);
      });

      const isScottishConstituency = type === 'scotland_constituency';

      const seatsSoFar =
        parseFloat(get('seats_declared')) ||
        Object.values(values).reduce(
          (total, value) => total + (parseFloat(value) || 0),
          0
        );

      const seatsAvailable =
        parseFloat(get('nseats_total')) ||
        parseFloat(get('seats_available')) ||
        null;

      return {
        type,
        onsCode: get('ons_code'),
        councilName: get('area_name'),
        votingStatus: get('voting_status'),
        gainOrHold: get('gain_or_hold') || get('gain_hold'),
        previousControl: get('prev_control') || get('prev_winner_party'),
        currentControl: get('current_control') || get('winner_party'),
        winnerName: get('winner_name'),
        lastUpdated: get('last_updated'),
        notes: get('notes'),
        seatsAvailable,
        seatsSoFar,
        isPercentageResult: isScottishConstituency,
        results: {
          current: {
            control: get('current_control') || get('winner_party'),
            ...values
          }
        }
      };
    });
  }
  
  function partyLabel(party) {
  switch (party) {
    case 'snp': return 'SNP';
    case 'labour': return 'Labour';
    case 'conservative': return 'Conservative';
    case 'libDem': return 'LibDems';
    case 'green': return 'Green';
    case 'reform': return 'Reform';
    case 'alba': return 'Alba';
    case 'independent': return 'Independent';
    case 'other': return 'Other';
    default: return party;
  }
}

  async function fetchData() {
    councilResults = await loadCsv(ENGLISH_COUNCIL_URL, 'england');
    welshResults = await loadCsv(WELSH_PARLIAMENT_URL, 'wales');
    scottishConstituencyResults = await loadCsv(SCOTTISH_CONSTITUENCY_URL, 'scotland_constituency');
    scottishRegionalResults = await loadCsv(SCOTTISH_REGION_URL, 'scotland_region');

    console.log('English loaded:', councilResults);
    console.log('Welsh loaded:', welshResults);
    console.log('Scottish constituency loaded:', scottishConstituencyResults);
    console.log('Scottish regional loaded:', scottishRegionalResults);
  }

  async function getMapItResult(cleanPostcode) {
    const response = await fetch(
      `https://mapit.mysociety.org/postcode/${cleanPostcode}`
    );

    const data = await response.json();

    console.log('MapIt response:', data);
    console.log('MapIt areas:', data.areas);

    if (!response.ok || !data.areas) return null;

    return data;
  }

  function findMapItArea(mapitResult, type) {
    if (!mapitResult?.areas) return null;

    return Object.values(mapitResult.areas).find(area =>
      area.type === type
    );
  }

  async function findCouncilByPostcode() {
    matchedResults = [];
    lookupMessage = '';

    if (!postcode.trim()) {
      await tick();
      sendIframeHeight();
      return;
    }

    try {
      const cleanPostcode = postcode.replace(/\s+/g, '').toUpperCase();

      const response = await fetch(
        `https://api.postcodes.io/postcodes/${cleanPostcode}`
      );

      const data = await response.json();

      console.log('Full postcode API response:', data);
      console.log('Postcode result:', data.result);
      console.log('Postcode codes:', data.result?.codes);

      if (!response.ok || !data.result) {
        lookupMessage = 'No result found for that postcode.';
        await tick();
        sendIframeHeight();
        return;
      }

      const postcodeResult = data.result;
      const country = postcodeResult.country;

      if (country === 'Wales') {
        const westminsterName =
          postcodeResult.parliamentary_constituency_2024 ||
          postcodeResult.parliamentary_constituency;

        const seneddCode =
          welshWestminsterToSeneddMap[normaliseName(westminsterName)];

        const match = welshResults.find(result =>
          result.onsCode === seneddCode
        );

        matchedResults = match ? [match] : [];

        if (!match) {
          lookupMessage = `This Welsh postcode maps from ${westminsterName}, but no matching Senedd result was found.`;
        }

      } else if (country === 'Scotland') {
        const mapitResult = await getMapItResult(cleanPostcode);

        const futureConstituency = findMapItArea(mapitResult, 'SPCF');
        const futureRegion = findMapItArea(mapitResult, 'SPEF');

        console.log('Future Scottish constituency:', futureConstituency);
        console.log('Future Scottish region:', futureRegion);

        const constituencyMatch = scottishConstituencyResults.find(result =>
          normaliseName(result.councilName) === normaliseName(futureConstituency?.name)
        );

      const mapitRegionName = normaliseName(futureRegion?.name);
const mappedRegionName = scottishRegionNameMap[mapitRegionName] || mapitRegionName;

const regionalMatch = scottishRegionalResults.find(result =>
  normaliseName(result.councilName) === mappedRegionName
);

        matchedResults = [constituencyMatch, regionalMatch].filter(Boolean);

        if (matchedResults.length === 0) {
          lookupMessage =
            'This is a Scottish postcode, but no matching Scottish Parliament result was found. Check the console output.';
        }

      } else {
        const onsCode = postcodeResult.codes?.admin_district;
        const authorityName = postcodeResult.admin_district;

        const match = councilResults.find(result =>
          result.onsCode === onsCode
        );

        matchedResults = match ? [match] : [];

        if (!match) {
          lookupMessage = `Your council appears to be ${authorityName}, but it was not found in this results list.`;
        }
      }

      console.log('Matched result objects:', matchedResults);

      window.parent.postMessage(
        {
          type: 'postcode_lookup_success',
          postcode: cleanPostcode,
          country,
          results: matchedResults.map(result => ({
            ons_code: result.onsCode,
            area: result.councilName,
            type: result.type
          }))
        },
        '*'
      );

      await tick();
      sendIframeHeight();

    } catch (err) {
      console.error(err);
      lookupMessage = 'There was a problem looking up that postcode.';
      await tick();
      sendIframeHeight();
    }
  }

  onMount(async () => {
    await fetchData();
    await tick();
    sendIframeHeight();

    window.addEventListener('resize', sendIframeHeight);

    return () => {
      window.removeEventListener('resize', sendIframeHeight);
    };
  });

  $: displayedResults = matchedResults;

  function partyColor(party) {
    switch (party) {
      case 'labour': return '#E91E63';
      case 'conservative': return '#2196F3';
      case 'reform': return '#9C27B0';
      case 'libDem': return '#FFC107';
      case 'plaidCymru': return '#008142';
      case 'snp': return '#FDF38E';
      case 'alba': return '#005EB8';
      case 'green': return '#4CAF50';
      case 'independent': return '#777777';
      default: return '#9E9E9E';
    }
  }

  function calculateTotalValue(results) {
    return Object.entries(results)
      .filter(([key]) => key !== 'control')
      .reduce((total, [, num]) => total + (parseFloat(num) || 0), 0);
  }

  function noResultValues(result) {
    return calculateTotalValue(result.results.current) === 0;
  }

  function orderPartiesByValue(results) {
    return Object.fromEntries(
      Object.entries(results)
        .filter(([party]) => party !== 'control')
        .sort((a, b) => parseFloat(b[1] || 0) - parseFloat(a[1] || 0))
    );
  }

  function resultTypeLabel(type) {
    switch (type) {
      case 'wales': return 'Welsh Parliament election';
      case 'scotland_constituency': return 'Scottish Parliament constituency seat';
      case 'scotland_region': return 'Scottish Parliament regional list';
      default: return '';
    }
  }

  function displayStatus(result) {
    const status = result.votingStatus?.toUpperCase();
    const previous = result.previousControl;
    const current = result.currentControl;
    const gainOrHold = result.gainOrHold?.toUpperCase();

    if (result.type === 'scotland_constituency') {
  if (!result.currentControl) return 'No result yet';

  const winnerText = result.winnerName
    ? `Winning candidate: ${result.winnerName}`
    : `${result.currentControl} leading`;

  return winnerText;
}

    if (['wales', 'scotland_region'].includes(result.type)) {
      if (status === 'BASELINE') return 'No result yet';
      if (result.seatsSoFar === 0) return 'No seats declared yet';
      return `${result.seatsSoFar} of ${result.seatsAvailable || '?'} seats declared`;
    }

    if (status === 'BASELINE') {
      return previous ? `Previous control: ${previous}` : 'No result yet';
    }

    if (!current) return 'No result yet';
    if (current === 'NOC') return 'No overall control';

    if (gainOrHold === 'GAIN' && previous && previous !== 'NOC') {
      return `${current} gain from ${previous}`;
    }

    if (gainOrHold === 'GAIN') return `${current} gain`;
    if (gainOrHold === 'HOLD') return `${current} hold`;
    if (previous === current) return `${current} hold`;
    if (previous) return `${current} gain from ${previous}`;

    return current;
  }

  function calculateBarWidth(value, result) {
    const num = parseFloat(value);

    if (!num) return 0;

    if (result.isPercentageResult) {
      return Math.min(num, 100).toFixed(2);
    }

    const denominator =
      result.seatsAvailable ||
      result.seatsSoFar ||
      calculateTotalValue(result.results.current);

    if (!denominator) return 0;

    return (100 * num / denominator).toFixed(2);
  }

  function resultSubLabel(result) {
    if (result.type === 'scotland_constituency') {
      return result.votingStatus === 'BASELINE'
        ? 'No result yet'
        : 'Vote share';
    }

    if (result.votingStatus === 'BASELINE') {
      return 'No result yet';
    }

    if (result.seatsAvailable) {
      return `${result.seatsSoFar} of ${result.seatsAvailable} seats declared`;
    }

    if (result.seatsSoFar > 0) {
      return `${result.seatsSoFar} seats declared so far`;
    }

    return 'No seats declared yet';
  }
</script>

<style>
  .results-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }

  .card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .header strong {
    display: block;
    font-size: 20px;
  }

  .header small {
    display: block;
    font-size: 14px;
    color: #666;
  }

  .results-bar {
    position: relative;
    height: 20px;
    background-color: #f0f0f0;
    margin: 10px 0;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
  }

  .bar {
    height: 100%;
    transition: width 0.5s ease;
  }

  .majority-marker {
    position: absolute;
    top: 0;
    left: 50%;
    bottom: 0;
    border-left: 2px dashed #333;
  }

  .result-text {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  .input {
    width: 100%;
    height: 40px;
    padding: 0 8px;
    border: 1px solid #030303;
    border-radius: 20px;
    font-size: 16px;
    line-height: 24px;
    outline: none;
    margin: 10px auto;
    display: block;
  }

  .button {
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 20px;
    background: #030303;
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .no-results {
    font-size: 16px;
    color: #666;
    text-align: center;
    padding: 20px;
  }
  .vote-share-list {
  margin-top: 12px;
}

.vote-row {
  display: grid;
  grid-template-columns: 120px 1fr 45px;
  align-items: center;
  gap: 10px;
  margin: 6px 0;
  font-size: 18px;
}

.vote-label {
  font-weight: 600;
}

.vote-bar-track {
  height: 28px;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.vote-bar {
  height: 100%;
}

.vote-value {
  font-weight: bold;
}
.winner-name {
  margin-top: 10px;
  font-size: 18px;
  text-align: center;
}

.gain-hold {
  margin-top: 6px;
  font-size: 16px;
  text-align: center;
  color: #666;
  text-transform: capitalize;
}
</style>

<input
  id="postcode"
  name="postcode"
  type="text"
  placeholder="Enter your postcode"
  bind:value={postcode}
  class="input"
/>

<button class="button" on:click={findCouncilByPostcode}>
  Find my result
</button>

{#if lookupMessage}
  <p class="no-results">{lookupMessage}</p>
{/if}

<div class="results-container">
  {#each displayedResults as result (result.onsCode + result.type)}
    <div class="card">
      <div class="header">
        <strong>{result.councilName}</strong>

        {#if resultTypeLabel(result.type)}
          <small>{resultTypeLabel(result.type)}</small>
        {/if}

        <small>{resultSubLabel(result)}</small>
      </div>

      {#if noResultValues(result)}
  <p class="no-results">No results yet</p>

{:else if result.isPercentageResult}
  <div class="result-text">
    {partyLabel(result.currentControl)}
  </div>

  {#if result.winnerName}
    <p class="winner-name">
      {result.winnerName}
    </p>
  {/if}

  {#if result.gainOrHold}
    <p class="gain-hold">
      {result.gainOrHold}
    </p>
  {/if}

{:else}
  <div class="results-bar">
    {#each Object.keys(orderPartiesByValue(result.results.current)) as party}
      {#if parseFloat(result.results.current[party]) > 0}
        <div
          class="bar"
          style="width: {calculateBarWidth(result.results.current[party], result)}%; background-color: {partyColor(party)};"
          title="{partyLabel(party)}: {result.results.current[party]} seats"
        ></div>
      {/if}
    {/each}

    {#if result.seatsAvailable}
      <div class="majority-marker"></div>
    {/if}
  </div>

  <div class="result-text">
    {displayStatus(result)}
  </div>
{/if}
    </div>
  {/each}
</div>